const TABS = {
    LOGIN: "login",
    REGISTER: "register",
    RESET: "reset",
  };

export default TABS;